<div class="news-card" id="card" [class.card--news-home]="isNewsroomHome()">
  <span
    class="news-card__content-line"
    [class.news-card__content-line--news-home]="isNewsroomHome()"
  >
  </span>
  <a [routerLink]="'/newsroom/' + config()?.id" class="news-card__link">
    <div
      class="news-card__header d-flex align-items-center justify-content-between"
      [class.news-card__header-newsHome]="isNewsroomHome()"
    >
      <div class="news-card__header-circle-container">
        <span class="news-card__header-circle"></span>
        <span
          class="news-card__header-circle news-card__header-circle--medium"
        ></span>
        <span
          class="news-card__header-circle news-card__header-circle--bright"
        ></span>
      </div>
      <div class="news-card__header-time d-flex align-items-center">
        <i class="news-card__header-time-clock ri-time-line"></i>

        <p class="display display-captions-s m-0">
          {{ config()?.readingTime }}
        </p>
      </div>
    </div>

    <div
      class="news-card__content"
      [class.news-card__content--news-home]="isNewsroomHome()"
    >
      <img
        class="news-card__content-img"
        [ngSrc]="'./assets/strapi-media/' + config()?.imgName"
        width="604"
        height="360"
        [alt]="config()?.altDescription"
      />
      <p class="news-card__content-caption display display-captions-s">
        {{ config()?.categoryName }}
      </p>

      <p
        class="news-card__content-text display display-2b"
        data-test="news-text-front"
      >
        {{ config()?.textFront }}
      </p>
    </div>
  </a>
</div>
